/* eslint-disable */
let self;
let blog_cards;
let selected_cats = [];

let all_post_ids, all_posts, cat_post_ids, current_category_id, loadMoreButton, shownItems, isCallingAjax, paged;
let posts_per_page = 12;

export class CatArchive {

  constructor() {
    self = this;

    // is the Cat Archive element even here?
    if (!$('.blog-page').length) return;

     //Fire up the ajax load
    //self.ajaxCaller();

    // All cards
    blog_cards = $('.blog-page__card');
    // Load more button
    loadMoreButton = $('a.btn-load-more');

    let catJSData = $('.catJSData');
    all_post_ids = catJSData.data('allPostIds');
    cat_post_ids = catJSData.data('catPostIds');
    current_category_id = catJSData.data('currentCategoryId');

    paged = 1;

    // if current cat is already filled
    if (current_category_id > 0) {
      // update mem and DOM
      self.filterAddCat(current_category_id);
    } else {
      // show all if no filter
      self.showBlogCards([]);
    }

    // On filter click, filter
    $('.category-filters')
    .on('click', 'li a', function (e) {
      e.preventDefault();

      let selected_cat = $(this)
      .data('id');

      // when current filter is de-selected
      if ($(this)
      .hasClass('is_current')) {
        // update visually
        $(this)
        .removeClass('is_current');
        // update mem and DOM
        self.filterRemoveCat(selected_cat);

      } else {
        // update visually
        $(this)
        .addClass('is_current');
        // update mem and DOM
        self.filterAddCat(selected_cat);
      }

    });

    // on load more
    $('body')
    .on('click', 'a.btn-load-more', function (e) {
      e.preventDefault();

      paged++;
      self.showCards();

    });

    // Fire up the auto-load
    self.initInfiniteLoad();

  }

  filterAddCat(cat) {
    // add it to memory
    selected_cats.push(cat);
    // update cards
    self.showBlogCards(selected_cats);
  }

  filterRemoveCat(cat) {
    // remove it from memory
    selected_cats = jQuery.grep(selected_cats, function (a) {
      return a !== cat;
    });
    // update cards
    self.showBlogCards(selected_cats);
  }

  // Receive array of selected cat_ids
  showBlogCards(cat_ids) {
    let blogIDs = [];
    paged = 1; // reset to first page

    // Show all if none selected
    if (!cat_ids.length) {

      // Update the DOM
      self.showCards(all_post_ids);

    } else {

      // Show cards from selected categories (AND compare)
      if (cat_ids.length === 1) {
        blogIDs = cat_post_ids[cat_ids[0]];
      }

      // Next: not the nicest solution, i admit.
      // Trying to find the elements that are in ALL category arrays. (AND)
      // (each array is a list of blog ids from a category)
      // Assume a person will not select more then 5 categories as a filter
      // if so, add extra, or come up with different solution
      if (cat_ids.length > 1) {
        blogIDs = cat_post_ids[cat_ids[0]].filter(element => cat_post_ids[cat_ids[1]].includes(element));
      }
      if (cat_ids.length > 2) {
        blogIDs = blogIDs.filter(element => cat_post_ids[cat_ids[2]].includes(element));
      }
      if (cat_ids.length > 3) {
        blogIDs = blogIDs.filter(element => cat_post_ids[cat_ids[3]].includes(element));
      }
      if (cat_ids.length > 4) {
        blogIDs = blogIDs.filter(element => cat_post_ids[cat_ids[4]].includes(element));
      }
      if (cat_ids.length > 5) {
        blogIDs = blogIDs.filter(element => cat_post_ids[cat_ids[5]].includes(element));
      }

      // Update the DOM
      self.showCards(blogIDs);

      self.initInfiniteLoad();
    }
  }

  // Receive array of IDs to show
  // if empty, show items from memory
  showCards(items = []) {
    if (items.length) {
      shownItems = items;
    }

    // hide all
    $.each(all_post_ids, function (index, value) {
      $('.blog-page__card#' + value)
      .hide();
    });

    // show selected cards
    $.each(shownItems, function (index, value) {
      //@ts-ignore
      if (index < (posts_per_page * paged)) {
        $('.blog-page__card#' + value)
        .show();
      }
    });

    // show the load more button
    loadMoreButton.hide();
    if (shownItems && Array.isArray(shownItems) && shownItems.length > (posts_per_page * paged)) {
      loadMoreButton.show();
    }

  }


  /**
   * Ajax to the backend
   */
  //ajaxCaller() {
  //  if (isCallingAjax) return;
  //
  //  // Show visual the AJAX call
  //  isCallingAjax = true;
  //  //$btnLoadMore.html('Ophalen...');
  //  //$search_overlay.fadeIn();
  //
  //  const postArguments = {
  //    action: 'get_categories',
  //    cat_id: false
  //  };
  //
  //  return $.ajax({
  //    // eslint-disable-next-line no-undef
  //    url: ajax_link,
  //    method: 'post',
  //    data: postArguments,
  //    success: resp => this.handleSubmitExtResponse(resp),
  //  });
  //
  //}

  /**
   * Display the results from the backend
   *
   * @param response
   */
  handleSubmitExtResponse(response) {
    isCallingAjax = false;

    if (response.errors) {
      console.log(response.errors)
    } else {

      all_post_ids = response.data.all_post_ids;
      all_posts = response.data.all_posts;
      cat_post_ids = response.data.cat_post_ids;

      $('.blog-page').append(all_posts);

      self.showCards(all_post_ids);

    }
  }
  /**
   * Infinite load more: Load if button comes into viewport
   */
  initInfiniteLoad() {
    $(window)
    .on('scroll', function () {

      // if button is visible, and in view, trigger a 'load more' action
      if ($('a.btn-load-more')
        .is(':visible')
        && self.isInViewport(document.querySelector('a.btn-load-more'))) {
        loadMoreButton.trigger('click');
      }
    });
  }

  /**
   * Helper to check if given element is in the viewport
   *
   * @param elem
   * @returns {boolean}
   */
  isInViewport = function (elem) {
    if (!elem) return false;

    let bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
}
